var _style, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlusNewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.9,
    y: 18.6,
    className: "st0",
    width: 21.3,
    height: 21.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,16.4L18.7,27.5c-0.7,0.8-2,0.8-2.7,0l0,0l-5.5-5.5c-0.7-0.8-0.7-2,0-2.8c0.7-0.8,2-0.8,2.7,0l4,4.1l9.5-9.6 c0.7-0.8,2-0.8,2.7,0l0,0C30.1,14.4,30.1,15.8,29.5,16.4z M4.7,19.9c0-4.5,2-8.6,5-11.4l3,3c0.3,0.3,1,0.3,1.3,0 c0.2-0.2,0.3-0.5,0.3-0.7V2.5c0-0.5-0.5-1-1-1H5.2c-0.8,0-1.3,1-0.7,1.7l2.5,2.7c-3.8,3.5-6.1,8.6-6.1,14.3 c0,9.3,6.3,17.1,14.8,19.1c1.2,0.3,2.3-0.7,2.3-2c0-1-0.7-1.7-1.5-2C9.9,33.5,4.7,27.4,4.7,19.9z M39.1,19.9 c0-9.3-6.3-17.1-14.8-19.1c-1.2-0.3-2.3,0.7-2.3,2c0,1,0.7,1.7,1.5,2c6.8,1.7,11.8,7.8,11.8,15.3c0,4.5-2,8.6-5,11.4l-3-3 c-0.3-0.3-1-0.3-1.3,0c-0.2,0-0.3,0.3-0.2,0.5v8.3c0,0.5,0.5,1,1,1h8.1c0.8,0,1.3-1,0.7-1.7L33.1,34C36.8,30.5,39.1,25.6,39.1,19.9 L39.1,19.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlusNewIcon);
export default __webpack_public_path__ + "static/media/add_plus_new_icon.985015a9fd24a0a69c3456341f1c0ddc.svg";
export { ForwardRef as ReactComponent };